module.exports = ExcelJS;


//////////////////
// WEBPACK FOOTER
// external "ExcelJS"
// module id = 4
// module chunks = 